<div *ngIf="loader.isLoading$ | async" class="spinner-overlay" role="status" aria-label="Loading page">
  <div class="center-screen">
    <div class="spinner"></div>
    <img class="brand-mark" [src]="logoUrl" alt="Buzzwave" />
  </div>
</div>
